import { render, staticRenderFns } from "./DonutChart44.vue?vue&type=template&id=f8087a08&scoped=true&"
import script from "./DonutChart44.vue?vue&type=script&lang=js&"
export * from "./DonutChart44.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8087a08",
  null
  
)

export default component.exports